var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGLplusGreyGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 462.3 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #555;\n      }\n\n      .cls-3 {\n        fill: #606060;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 371.17,
    y1: 40.17,
    x2: 409.74,
    y2: 40.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ff8201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 336.96,
    y1: 44.77,
    x2: 462.3,
    y2: 44.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 67.84,
    y1: -657.94,
    x2: 121.6,
    y2: -657.94,
    gradientTransform: "translate(0 -614) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ff8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fa9f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f7b334"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.83,35.85h-6.1l-1.57,8.64h5.96c2.8,0,4.36-2.19,4.76-4.3.36-2.08-.36-4.34-3.05-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m459.01,22.97h-121.69l17.07,20.69-17.44,22.9h105.19c1.29,0,2.46-.75,3-1.93l16.86-37.01c.99-2.18-.6-4.66-3-4.66Zm-82.28,25h-6.17l-1.31,7.32c-.18,1.04-1.24,1.94-2.36,1.94-1.02,0-1.67-.9-1.49-1.94l3.74-20.87c.25-1.29,1.23-2.08,2.4-2.08h7.99c5.41,0,6.94,3.91,6.21,7.86-.73,3.95-3.6,7.78-9.01,7.78Zm22.97,7.35c-.18.97-1.09,1.72-2.07,1.72h-10.25c-1.16,0-1.92-.79-1.71-2.08l3.78-20.87c.22-1.04,1.16-1.94,2.18-1.94,1.13,0,1.89.9,1.67,1.94l-3.49,19.44h8.43c.98,0,1.63.79,1.45,1.79Zm10.22,2.08c-5.01,0-8.68-3.52-7.7-8.93l2.58-14.38c.18-1.04,1.16-1.94,2.18-1.94,1.13,0,1.86.9,1.67,1.94l-2.61,14.38c-.58,3.19,1.67,5.27,4.54,5.27s5.81-2.08,6.39-5.27l2.58-14.38c.18-1.04,1.2-1.94,2.32-1.94,1.02,0,1.71.9,1.53,1.94l-2.62,14.38c-.98,5.42-5.85,8.93-10.86,8.93Zm30.41-18.44c-1.2.36-1.89-.14-2.22-1.11-.8-1.9-2.43-2.22-3.81-2.22-2.29,0-4.5,1.36-4.9,3.41-.18.97-.04,2.47,2.76,3.23l3.05.82c4.79,1.29,6.43,4.12,5.38,7.68-1.05,3.87-4.94,6.64-9.73,6.64-4.18,0-6.9-2.3-7.45-5.27-.18-.97.51-2.15,1.57-2.4,1.12-.29,2,.07,2.32,1.22.47,1.62,1.49,2.98,4.18,2.98,2.94,0,4.76-1.58,5.34-3.37.58-2.3-.98-3.44-3.23-4.02l-3.01-.79c-5.16-1.37-5.41-4.45-5.01-6.64.76-4.23,5.12-7.07,9.52-7.07,3.81,0,6.03,1.51,6.68,4.59.18.93-.44,2.04-1.42,2.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m134.3,30.5c-.3-.4-.7-.9-1-1.3l-.3-.3c-.6-.7-1.3-1.4-2-2h0c-.3-.3-.7-.5-1.2-.5s-1,.2-1.3.6h0l-3.7,5.2h0c-.2.3-.3.6-.3,1,0,.5.2.9.5,1.2h0c.9.8,1.6,1.7,2.2,2.7,1,1.7,1.7,3.6,1.9,5.6,0,.3.1.7.1,1v.2c0,7.1-5.8,12.9-12.9,12.9h0c-4.2,0-8.1-2-10.5-5.4l-14.5-20.4c-4.2-5.9-11.1-9.4-18.3-9.5-12.4,0-22.4,10.1-22.4,22.5,0,.8,0,1.5.1,2.2v.1c.1.8.2,1.5.3,2.2v.1c1,4.7,3.4,8.9,7,12.1.3.4.8.6,1.3.6.7,0,1.2-.4,1.5-1h0l3.3-4.7c.2-.3.4-.6.4-1s-.2-.8-.5-1.2h0c-2.6-2.5-4.1-6-4-9.6-.1-3.4,1.2-6.6,3.6-9,5-5.1,13.2-5.2,18.3-.3.6.6,1.1,1.2,1.5,1.8l14.7,20.7c7.2,10.1,21.2,12.4,31.3,5.2s12.4-21.2,5.2-31.3c-.1-.1-.2-.2-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m43.4,22.8h-5.4c-1.1,0-2,.9-2,2v1.5c0,.4-.3.7-.7.7-.2,0-.4-.1-.5-.2-3.6-3.2-8.2-4.9-12.9-4.9C9.4,21.9,0,31.7,0,44.6s9.2,22.4,21.9,22.4c5.9,0,11.3-2.4,14.2-6.3-.2,11.7-4.9,17.5-14.3,17.5-4.4,0-8.5-2.2-11-5.9-.5-.8-1.6-1.1-2.5-.7-1.3.7-3.2,1.7-4.5,2.4-.5.3-.9.7-1,1.2s-.1,1,.2,1.4c4,6.5,11.2,10.5,18.8,10.4,15.6,0,23.5-9.4,23.5-28V24.8c0-1.1-.8-1.9-1.9-2Zm-20.8,34.9c-7.6,0-13.1-5.4-13.1-13.2-.2-7.1,5.4-13.1,12.5-13.3h.6c6.4,0,13.4,4.2,13.4,13.3,0,8.6-6.9,13.2-13.4,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.2,0h-5.4c-1.1,0-2,.9-2,2v23.9c0,.4-.4.8-.8.8-.2,0-.4-.1-.5-.2-3.1-2.9-7.8-4.5-12.9-4.5-12.6,0-21.7,9.5-21.7,22.5s9.3,22.5,21.8,22.5c4.7,0,9.3-1.6,12.9-4.7.3-.3.8-.3,1.1,0,.1.1.2.3.2.5v1.3c0,1.1.9,2,2,2h5.4c1.1,0,2-.9,2-2V2c-.1-1.1-1-2-2.1-2h0Zm-7.5,44.3c0,9.2-6.9,13.4-13.3,13.4-7.4,0-13-5.8-13-13.4s5.5-13.1,13-13.1c6.6,0,13.3,4.5,13.3,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m199.4,0h5.5c1.1,0,2,.9,2,2v62.1c0,1.1-.9,2-2,2h-5.5c-1.1,0-2-.9-2-2V2c0-1.1.9-2,2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m234.2,21.9c-12.8,0-22.1,9.4-22.1,22.4s9.3,22.6,22.1,22.6c8.4,0,15.4-3.7,19.1-10.1.5-1,.2-2.2-.7-2.7-.1,0-.2-.1-.3-.1-.7-.2-1.3-.5-2-.7-.9-.3-1.7-.6-2.5-.9-.8-.4-1.8-.1-2.3.6-2.5,3.5-6.7,5.5-11,5.3-6.4,0-11.2-3.6-12.7-9.3-.1-.2,0-.4.1-.6.1-.2.4-.3.6-.3h31.2c1.1,0,2-.8,2-1.9v-1.9c-.1-13.2-8.9-22.4-21.5-22.4Zm-12.4,17.7c1.4-5.6,6.2-9.1,12.4-9.1s10.5,3.4,11.9,9.1c.1.4-.2.8-.6.9h-23c-.2,0-.5-.1-.6-.3-.1-.1-.2-.3-.1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m303.6,22.8h-5.4c-1.1,0-1.9.9-2,2v1.2c0,.3-.2.6-.4.7-.3.1-.6.1-.8-.1-3.6-3.1-8.2-4.7-12.9-4.6-12.7,0-21.9,9.5-21.9,22.5s9.4,22.5,21.9,22.5c4.7,0,9.3-1.7,12.9-4.8.2-.2.5-.3.8-.1.3.1.4.4.4.7v1.4c0,1.1.9,2,2,2h5.4c1.1,0,2-.9,2-2V24.8c-.1-1.1-.9-1.9-2-2Zm-7.5,21.5c0,9.2-6.9,13.4-13.3,13.4-7.4,0-13.1-5.8-13.1-13.4-.3-7,5.2-12.9,12.2-13.1h.9c6.6,0,13.3,4.5,13.3,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m335.6,21.9c-4.7-.1-9.3,1.7-12.8,4.8-.2.2-.5.3-.8.1-.3-.1-.4-.4-.4-.7v-1.4c0-1.1-.9-2-2-2h-5.6c-1.1,0-2,.9-2,2v59.7c0,1.1.9,2,2,2h5.5c1.1,0,2-.9,2-2v-21.5c0-.3.2-.6.4-.7.3-.1.6-.1.8.1,3.5,3.1,8.1,4.7,12.8,4.6,12.5,0,21.6-9.4,21.6-22.4s-9-22.6-21.5-22.6Zm12.1,22.8c0,7.7-5.3,13.1-13,13.1-6.5,0-13.1-4.5-13.1-13.1,0-9.3,6.8-13.5,13.1-13.5,7.6,0,13,5.6,13,13.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.6,23.3c0-.9-.7-1.7-1.6-1.7h-.1c-1.7-.2-3.4-.2-5.1-.1l-1,.1c-6.3.7-12,4.1-15.7,9.3l-14.5,20.6c-2.2,3.4-6,5.5-10,5.6h-.1c-.5,0-.9.3-1.2.7h0l-.1.1-4,5.6c-.6.7-.4,1.8.3,2.4.2.1.3.2.5.3h.1c2.2.2,4.4.3,6.6.2,6.3-.7,12.1-4.1,15.8-9.3l14.4-20.4c2.3-3.1,5.8-5.1,9.7-5.4h.1c.6,0,1.2-.3,1.4-.9l4.2-6c.2-.4.3-.7.3-1.1Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGLplusGreyGradient);
export default __webpack_public_path__ + "static/media/GLplus_grey_gradient.a27b3e60f88b518244ac6b3942ff2521.svg";
export { ForwardRef as ReactComponent };